import * as TYPES from './types';

const actions = {
    set_count_add(vuex, params=null) {
        // axios.get("/customer/user_info").then(res => {
        //     commit(TYPES.SET_COUMT, res.data);
        // });
        vuex.commit(TYPES.SET_COUMT_ADD, params);
    },
    set_app_key(vuex, params=null) {
        vuex.commit(TYPES.SET_APP_KEY, params);
    },
    set_search_word(vuex, params=null) {
        vuex.commit(TYPES.SET_SEARCH_WORD, params);
    },
}
export default actions